import { hyphenateSync as hyphenate } from "hyphen/en";
import { hyphenateSync as hyphenateRu } from "hyphen/ru";

const _hyphen = (text = '') => {
    if (typeof text !== 'string') {
        return '';
    }
    let words = text.split(' ') ?? [text];
    let newText = words.map((word, index) => {
        if (word.length <= 5) return word;
        const resEn = hyphenate(word)
        if (resEn.includes('\u00AD')) return resEn;
        const resRu = hyphenateRu(resEn);
        if (resRu.includes('\u00AD')) return resRu;
        if ((resRu.search(/(\.){3}$/) !== -1) && (words.length === index + 1)) {
            const substrings = resRu.replace(/(\.){3}$/, '').match(/.{1,3}/g) ?? []
            return (substrings.join('\u00AD') + '...')
        } else if (resRu.includes('\n')) {
            const substrings = resRu.split('\n')
            console.log(substrings)
            const newsum = substrings.map(str => {
                console.log(str)
                const _substrings = str.match(/.{1,3}/g) ?? [];
                const _newsum = _substrings.join('\u00AD')
                return _newsum;
            })

            return newsum.join('\n');
        } else {
            const substrings = resRu.match(/.{1,3}/g)
            const newsum = substrings.join('\u00AD')
            return newsum;
        }
    })
    return newText

}
function hyphen(text) {
    return _hyphen(text).join(' ')
}
export default hyphen;